import React, { useState, useEffect } from "react"
import {
  Modal,
  Form,
  Input,
  DatePicker,
  message,
  Row,
  Col,
  InputNumber,
} from "antd"
import dayjs from "dayjs"
import ReportService from "src/services/ReportService"

const ViewSimDetailModal = ({ visible, onClose, id , api, historyDetail = "true" }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    form.resetFields()
    onClose()
  }

  useEffect(() => {
    const fetchSim = async () => {
      try {
        setLoading(true)
        const response = await api(id)
        const history = historyDetail ? response?.success?.history : response?.success?.sim_details

        const data = historyDetail ? history.flatMap(item => item.sims || []) : history || []

        const simsFormatted = data.map(item => ({
          id: item.ID || "",
          phone_number: item.phone_number || "",
          serial_number: item.serial_number || "",
          // activation_deadline: item.activation_deadline
          //   ? dayjs(item.activation_deadline)
          //   : null,
          // supplier: item.supplier?.name || "",
          // carrier: item.carrier?.name || "",
          // package: item.package?.name || "",
          // unit_price: Number(item.unit_price) || 0,
        }))
        form.setFieldsValue({ sims: simsFormatted })
      } catch (error) {
        console.error("Lỗi khi lấy danh sách SIM", error)
        message.error("Không thể lấy danh sách SIM")
      } finally {
        setLoading(false)
      }
    }

    fetchSim()
  }, [id, form])

  return (
    <Modal
      title="Danh sách SIM"
      open={visible}
      onCancel={handleClose}
      width={1200}
      footer={null} // chỉ có nút X (Đóng)
      confirmLoading={loading}
      styles={{
        body: {
          maxHeight: "70vh",
          overflowY: "auto",
        },
      }}
    >
      <Form form={form} layout="vertical">
        <Form.List name="sims">
          {fields =>
            fields.map(({ key, name }) => (
              <div
                key={key}
                style={{
                  padding: "12px",
                  marginBottom: "16px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <Row gutter={16}>
                  {/* <Form.Item name={[name, "id"]} hidden>
                    <Input type="hidden" />
                  </Form.Item>
                  <Col xs={24} sm={12} md={6}>
                    <Form.Item name={[name, "supplier"]} label="Nhà cung cấp">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Form.Item name={[name, "carrier"]} label="Nhà mạng">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={5}>
                    <Form.Item name={[name, "package"]} label="Gói cước">
                      <Input disabled />
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name={[name, "phone_number"]}
                      label="Số thuê bao"
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name={[name, "serial_number"]}
                      label="Số seri SIM"
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={12} md={5}>
                    <Form.Item
                      name={[name, "activation_deadline"]}
                      label="Hạn kích hoạt"
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD-MM-YYYY"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Form.Item name={[name, "unit_price"]} label="Đơn giá">
                      <InputNumber
                        style={{ width: "100%" }}
                        disabled
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                      />
                    </Form.Item>
                  </Col> */}
                </Row>
              </div>
            ))
          }
        </Form.List>
      </Form>
    </Modal>
  )
}

export default ViewSimDetailModal
